/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Why the exam clock is paused.
 */
export type OralExamPauseReason = (typeof OralExamPauseReason)[keyof typeof OralExamPauseReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamPauseReason = {
  lecturer_pause: 'lecturer_pause',
  help_requested: 'help_requested',
  media_disabled: 'media_disabled',
  technical: 'technical',
} as const;
